// extracted by mini-css-extract-plugin
export default {"CommentListPlaceholder":"ih_a bia_jk","CommentListPlaceholder--Legacy":"ih_b bia_rc bia_wq"};